import React, { useContext } from 'react';
import { Box, Button, LinearProgress } from '@mui/material';
import {
    DataGridPremium,
    GridToolbar,
    useGridApiRef,
} from '@mui/x-data-grid-premium';

import { commaMoneyFormat } from '../../../../Utils';

const FeesFineRulesView = ({ violationView, feeFineRuleRows, loadingFFRules }) => {

    const apiRef = useGridApiRef();

    const columns = [
        {
            field: 'description',
            headerName: 'Description',
            flex: 3,
            diplay: 'flex',
        },
        {
            field: 'category',
            headerName: 'Category',
            flex: 1.5,
            display: 'flex',
            align: 'center'
        },
        //{
        //    field: 'payOrderHeirarchy',
        //    headerName: 'Sort Order',
        //    flex: 1,
        //    align: 'center',
        //    headerAlign: 'right'
        //},
        //{
        //    field: 'payOrder',
        //    headerName: 'Pay Order',
        //    flex: 1,
        //    align: 'center'
        //},
        {
            field: 'assessAmount',
            headerName: 'Assessed',
            flex: 1,
            type: 'number',
            renderCell: (params) => {
                const isExpandableRow = params.rowNode?.type === "group";
                return (
                    <>{isExpandableRow ? null : new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(params.value || 0.00)}</>
                )
            },
            align: "right",
            headerAlign: "right"
        },
        {
            field: 'suspendAmount',
            headerName: 'Suspended',
            flex: 1,
            type: 'number',
            renderCell: (params) => {
                const isExpandableRow = params.rowNode?.type === "group";
                return (
                    <>{isExpandableRow ? null : new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(params.value || 0.00)}</>
                )
            },
            align: "right",
            headerAlign: "right"
        },
    ];


    const sortedRows = [...feeFineRuleRows].sort((a, b) => {
        if (a.payOrderHeirarchy === 2 && b.payOrderHeirarchy !== 2) {
            return -1;
        }
        if (b.payOrderHeirarchy === 2 && a.payOrderHeirarchy !== 2) {
            return 1;
        }
        if (a.payOrderHeirarchy === 2 && b.payOrderHeirarchy === 2) {
            if (a.description === violationView.description) {
                return -1;
            }
            if (a.descrption > b.description) {
                return -1;
            }
            return 1;
        }
        if (a.payOrderHeirarchy === 1 && a.payOrder > b.payOrder) {
            return 1;
        }
        if (a.payOrderHeirarchy === 1 && a.payOrder < b.payOrder) {
            return -1;
        }
        if (a.payOrderHeirarchy === 3) {
            return 1;
        }
        return 0;
    });

    // documentation for group columns
    //const initialState = useKeepGroupedColumnsHidden({
    //    apiRef,
    //    initialState: {
    //        rowGrouping: {
    //            model: groupingModel
    //        }
    //    }
    //});

    //useEffect(() => {
    //    if (sortedRows.length > 0) {
    //        const fines = sortedRows.filter(row => row.category === 'FINE');
    //        console.log('fines: ', fines);

    //        return fines.length > 0 ? setGroupingModel(['category']) : setGroupingModel([]);
    //    }

    //}, [feeFineRows, sortedRows]);

    //useEffect(() => {
    //    // Ensure grid is initialized before trying to group
    //    if (sortedRows.length > 0) {
    //        if (apiRef.current) {
    //            const fineRows = sortedRows.filter((row) => row.category === 'FINE');

    //            // If there are rows with category 'FINE', set the groupBy model dynamically
    //            if (fineRows.length > 0) {
    //                apiRef.current.setState((prevState) => ({
    //                    ...prevState,
    //                    rowGrouping: {
    //                        ...prevState.rowGrouping,
    //                        model: ['category'],  // Group by 'category' if 'FINE' rows exist
    //                    },
    //                }));
    //                apiRef.current.forceUpdate(); // Force grid to re-render with new state
    //            } else {
    //                // Clear grouping if 'FINE' rows do not exist
    //                apiRef.current.setState((prevState) => ({
    //                    ...prevState,
    //                    rowGrouping: {
    //                        ...prevState.rowGrouping,
    //                        model: [], // No grouping if no 'FINE' rows
    //                    },
    //                }));
    //                apiRef.current.forceUpdate(); // Force grid to re-render with new state
    //            }
    //        }
    //    }
    //}, [sortedRows, apiRef]); // Re-run when rows change


    return (
        <Box sx={{ height: '35vh' }}>
            <DataGridPremium
                rows={sortedRows}
                columns={columns}
                apiRef={apiRef}
                defaultGroupingExpansionDepth={-1}
                disableMultipleRowSelection
                hideFooterRowCount
                hideFooterSelectedRowCount
                slots={{ loadingOverlay: LinearProgress, toolbar: GridToolbar }}
                loading={loadingFFRules}
                getRowId={(row) => row.id}
                slotProps={{
                    toolbar: {
                        showQuickFilter: true,
                        printOptions: { disableToolbarButton: true }
                    },
                }}
                localeText={{ noRowsLabel: 'Select a violation above to display or add fees and fines to selected violation' }}
                initialState={{
                    rowGrouping: {
                        model: ['category']
                    },
                    pagination: { paginationModel: { pageSize: 75 } },
                    density: 'compact'
                }}
                autosizeOptions={{ columns: ['category', 'description'], includeOutliers: true, includeHeaders: false }}
                sx={{
                    '.MuiTablePagination-displayedRows, .MuiTablePagination-selectLabel': {
                        marginTop: '1em',
                        marginBottom: '1em'
                    },
                    "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
                        outline: "none !important",
                    }, "&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus": {
                        outline: "none !important",
                    },
                    maxHeight: '35vh',
                    '& .MuiDataGrid-footerContainer': {
                        //height: "20px", // Set the footer height explicitly
                        maxHeight: "2vh",
                        minHeight: '2vh',
                    },
                }}
            />
        </Box>
    );
};

export default FeesFineRulesView;